import { orderBy } from 'lodash';
import { getPropByString } from './objectUtils';

/**
 * @description Utility function that allows sorting by key and order
 * (function needs to be passed to Object.sort method)
 * by default expected to sort on strings except if numericSort set to true
 * and in this case the key references a property of number type
 * the sort covers strings with accented characters é, è, ...
 * @param {Object.key} key Object key defining by which value the target object must be sorted by
 * @param {string} [order='asc'] A string parameter that defines whether the target Object must be sorted by ascendant order ("asc", default) or descendant order ("desc")
 * @param {boolean} [numericSort=false] if true sort expected to be done on numeric values
 * @returns -1 or 1 depending on sorting order
 */
export const dynamicSort = (key, order = 'asc', numericSort = false) => {
  const sortOrder = order === 'desc' ? -1 : 1;
  if (key === 'lastName') {
    return (a, b) => sortLastNameFirstName(a, b, sortOrder);
  }
  if (numericSort) {
    return (a, b) => {
      const propA = getPropByString(a, key);
      const propB = getPropByString(b, key);
      const valA = propA ? parseInt(propA, 10) : 0;
      const valB = propB ? parseInt(propB, 10) : 0;
      return (valA - valB) * sortOrder;
    };
  }
  return (a, b) => {
    const propA = getPropByString(a, key);
    const propB = getPropByString(b, key);
    const valA = propA ? propA.toLowerCase() : '';
    const valB = propB ? propB.toLowerCase() : '';
    return valA.localeCompare(valB) * sortOrder;
  };
};

export const ascendantSort = (a, b) => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};

/**
 * Order events by specific order
 * @function
 * @param {array} events The events to sort
 * @param {'asc' | 'desc'} order The sort order
 * @returns {array} Returns the new sorted array
 */
export const orderEventsByDate = (events, order) => orderBy(events, [(event) => new Date(event.dateStart)], [order]);

/**
 * performs sort on objects having both lastName and firstName properties
 * objects first sorted on lastName and then if same on firstName values
 * sort can be asc or desc
 * @param {Object} a - first object to compare
 * @param {Object} b - second object to compare
 * @param {number} sortOrder - 1 if ascending sort (default) or -1 for descending sort
 * @returns {0|1|-1} depending on how a compares to b
 */
export const sortLastNameFirstName = (a, b, sortOrder = 1) => {
  let result = a.lastName.localeCompare(b.lastName);
  return result !== 0 ? result * sortOrder : sortOrder * a.firstName.localeCompare(b.firstName);
};
